import { Injectable } from '@angular/core';
import { SNACKBAR_DURATION_ERROR, SNACKBAR_DURATION_SUCCESS } from '../app.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BooleanSettingWithMetadata, CpmsWithMetadata, DaySchedule, DelayedStartWithMetaData, FreeStringSettingWithMetadata, NumberSettingWithMetadata, StringSettingWithMetadata, ValueWithMetadata } from '../models';

@Injectable({
	providedIn: 'root'
})
export class ChargerSettingsService {

	returnStringSettingWithMetadata(valueWithMetadata: ValueWithMetadata): StringSettingWithMetadata | undefined {
		if ((valueWithMetadata) && ('value' in valueWithMetadata)) {
			return valueWithMetadata as StringSettingWithMetadata;
		}
		return undefined;
	}

	returnFreeStringSettingWithMetadata(valueWithMetadata: ValueWithMetadata): FreeStringSettingWithMetadata | undefined {
		if ((valueWithMetadata) && ('value' in valueWithMetadata)) {
			return valueWithMetadata as FreeStringSettingWithMetadata;
		}
		return undefined;
	}

	returnNumberSettingWithMetadata(valueWithMetadata: ValueWithMetadata): NumberSettingWithMetadata | undefined {
		if ((valueWithMetadata) && ('value' in valueWithMetadata)) {
			return valueWithMetadata as NumberSettingWithMetadata;
		}
		return undefined;
	}

	returnBooleanSettingWithMetadata(valueWithMetadata: ValueWithMetadata): BooleanSettingWithMetadata | undefined {
		if ((valueWithMetadata) && ('value' in valueWithMetadata)) {
			return valueWithMetadata as BooleanSettingWithMetadata;
		}
		return undefined;
	}

	returnDelayedStartWithMetaData(valueWithMetadata: ValueWithMetadata): DelayedStartWithMetaData | undefined {
		if ((valueWithMetadata) && ('value' in valueWithMetadata) && (valueWithMetadata.value) && (typeof valueWithMetadata.value === 'object') && ('beginTimeHour' in valueWithMetadata.value) && ('beginTimeMinute' in valueWithMetadata.value)) {
			return valueWithMetadata as DelayedStartWithMetaData;
		}
		return undefined;
	}

	returnDaySchedule(valueWithMetadata: ValueWithMetadata): DaySchedule | undefined {
		if (valueWithMetadata) {
			return valueWithMetadata as DaySchedule;
		}
		return undefined;
	}

	returnCpmsWithMetaData(valueWithMetadata: ValueWithMetadata): CpmsWithMetadata | undefined {
		if (valueWithMetadata) {
			let cpmsWithMetadata = valueWithMetadata as CpmsWithMetadata;
			if (!('value' in cpmsWithMetadata)) {
				cpmsWithMetadata.value = { centralSystem: '', url: '' }
			}
			return cpmsWithMetadata;
		}
		return undefined;
	}


	openSnackbar(snackBar: MatSnackBar, success: boolean, errorMessage?: string, action?: string): boolean { 
		const CLOSE = $localize`:@@Close:Close`;

		if (!action) action = $localize`:@@Save:Save`;

		if (success) {
			snackBar.open(action + ' ' + $localize`:@@Successfully:successfully`, CLOSE, {
				duration: SNACKBAR_DURATION_SUCCESS,
				panelClass: ['snackbar-success']
			});
			return true;
		} else {
			snackBar.open(action + ' ' + $localize`:@@Failed:Failed` + ': ' + errorMessage, CLOSE, {
				duration: SNACKBAR_DURATION_ERROR,
				panelClass: ['snackbar-error']
			});
			return false;
		}
	}

}
